import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import "../css/header.css";
import DashSearchbar from "./searchBox/DashSearchbar";
import PlanExpired from "../Assets/expirePlan.png";
import { ZustandStore } from "../../store/zustand-store";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTab = useMediaQuery("(max-width:768px)");
  const { customer_plan, plan_loaded } = ZustandStore((state) => state);

  const isDashboardPage = useMemo(() => {
    return pathname === "/dashboard" || pathname === "/projects";
  }, [pathname]);

  if (!isDashboardPage) return null;
  return (
    <>
      {!isMobile ? <DashSearchbar /> : null}
      {customer_plan?.plan_name === "Free" && plan_loaded ? (
        <div className="expireplan mb-3 ">
          {!isTab ? (
            <div
              style={{ width: "17%", display: "flex", alignItems: "center" }}
            >
              <img
                src={PlanExpired}
                alt="planexpire"
                loading="lazy"
                className="w-100"
                style={{ height: "150px", objectFit: "contain" }}
              />
            </div>
          ) : null}
          <div className="text-container p-3">
            <h2>Unlock Premium Limits FREE for 30 Days</h2>
            <p>
              Want premium features without the premium price? Share us with
              your network and instantly unlock 30 days of premium limits - no
              payment required.
            </p>
            <p>
              <a
                href="https://colorful-chatter-885.notion.site/Free-Credits-91f8f39c49b94b76abc11a6ec3e85f92"
                target="_blank"
              >
                <span>Earn Free Credits Now!</span>
              </a>
            </p>
            <div className="footer-button">
              <Link to={"/upgrade"}>
                <button>{t("pl_add.pl_expand.button")}</button>
              </Link>
              <p>{t("pl_add.pl_expand.start_note")}</p>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default React.memo(Header);
